export default __webpack_public_path__ + "static/media/thank-you.84770961.jpg";